<template>
    <div id="SurveyQuestions">
        <div class="title-text">
            <h1>{{ $t("surveyIntroductionText") }}</h1>
        </div>
        <div class="content">
            <div class="module-survey-questions">
                <!-- Soru 1 -->
                <div class="question">
                    <span class="question-label">{{ $t("sectorQuestionText") }}</span>
                    <div class="custom-dropdown" :class="{ active: isSectorOpen }" ref="sectorDropdown">
                        <div class="dropdown-header" tabindex="0" @click="toggleSectorDropdown">
                            {{  selectedSector || $t('sectorPlaceholderText') }}
                            <span class="dropdown-arrow"></span>
                        </div>
                        <ul class="dropdown-list" :class="{ open: isSectorOpen }">
                            <li class="dropdown-item" @click="selectSector" data-value="Teknoloji">{{ $t("technologySector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Sağlık">{{ $t("healthSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Eğitim">{{ $t("educationSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Finans">{{ $t("financeSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Üretim">{{ $t("productionSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Perakende">{{ $t("retailSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Turizm">{{ $t("tourismSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Lojistik">{{ $t("logisticsSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="E-Ticaret">{{ $t("ecommerceSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Medya">{{ $t("mediaSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Enerji">{{ $t("energySector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="İnşaat">{{ $t("constructionSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Tarım">{{ $t("agricultureSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Hukuk">{{ $t("lawSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Danışmanlık">{{ $t("consultingSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Gıda">{{ $t("foodSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Otomotiv">{{ $t("automotiveSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Spor">{{ $t("sportsSector") }}</li>
                            <li class="dropdown-item" @click="selectSector" data-value="Diger">{{ $t("otherOptionText") }}</li>
                        </ul>
                    </div>
                    <input
                        class="question-input"
                        type="text"
                        v-model="answers.otherSector"
                        :placeholder="$t('otherSpecifyOptionText')"
                        v-if="selectedSector === 'Diger'"
                    >
                </div>
                <!-- Soru 2 -->
                <div class="question">
                    <span class="question-label">{{ $t("departmentQuestionText") }}</span>
                    <div class="custom-dropdown" :class="{ active: isOpen }" ref="dropdown">
                        <div class="dropdown-header" tabindex="0" @click="toggleDropdown">
                            {{ selectedText }}
                            <span class="dropdown-arrow"></span>
                        </div>
                        <ul class="dropdown-list" :class="{ open: isOpen }">
                            <li class="dropdown-item" @click="selectItem" data-value="Satış">{{ $t("salesOptionText")
                                }}
                            </li>
                            <li class="dropdown-item" @click="selectItem" data-value="Destek">{{ $t("supportOptionText")
                                }}
                            </li>
                            <li class="dropdown-item" @click="selectItem" data-value="IT">{{ $t("itOptionText") }}</li>
                            <li class="dropdown-item" @click="selectItem" data-value="Yazılım">
                                {{ $t("softwareOptionText") }}
                            </li>
                            <li class="dropdown-item" @click="selectItem" data-value="Pazarlama">
                                {{ $t("marketingOptionText") }}
                            </li>
                            <li class="dropdown-item" @click="selectItem" data-value="CEO">{{ $t("ceoOptionText") }}
                            </li>
                            <li class="dropdown-item" @click="selectItem" data-value="Kurucu">{{ $t("founderOptionText")
                                }}
                            </li>
                            <li class="dropdown-item" @click="selectItem" data-value="Müdür">{{ $t("managerOptionText")
                                }}
                            </li>
                            <li class="dropdown-item" @click="selectItem" data-value="İş Geliştirme">
                                {{ $t("businessDevelopmentOptionText") }}
                            </li>
                            <li class="dropdown-item" @click="selectItem" data-value="Tasarım">{{ $t("designOptionText") }}</li>
                            <li class="dropdown-item" @click="selectItem" data-value="Diger">{{ $t("otherOptionText") }}</li>
                        </ul>
                    </div>
                    <input
                        class="question-input"
                        type="text"
                        v-model="answers.otherDepartment"
                        :placeholder="$t('otherSpecifyOptionText')"
                        v-if="selectedText === 'Diger'"
                    >
                </div>
                <!-- Soru 3 -->
                <div class="question">
            <span class="question-label">{{ $t("heardAboutUsQuestionText") }}</span>
            <div class="card" @click="toggleCheckbox($event)">
                <label class="check-box">
                    <input type="checkbox" ref="checkbox" />
                    <span class="checkmark"></span>
                </label>
                <img src="../../../assets/youtube.svg" alt="Social Media" class="logo" />
                <div class="text">{{ $t("youtubeOptionText") }}</div>
            </div>
            <div class="card" @click="toggleCheckbox($event)">
                <label class="check-box">
                    <input type="checkbox" ref="checkbox" />
                    <span class="checkmark"></span>
                </label>
                <img src="../../../assets/linkedin-logo.svg" alt="LinkedIn" class="logo" />
                <div class="text">{{ $t("linkedInOptionText") }}</div>
            </div>
            <div class="card" @click="toggleCheckbox($event)">
                <label class="check-box">
                    <input type="checkbox" ref="checkbox" />
                    <span class="checkmark"></span>
                </label>
                <img src="../../../assets/internet-logo.svg" alt="Social Media" class="logo" />
                <div class="text">{{ $t("socialMediaOptionText") }}</div>
            </div>
            <div class="card" @click="toggleCheckbox($event)">
                <label class="check-box">
                    <input type="checkbox" ref="checkbox" />
                    <span class="checkmark"></span>
                </label>
                <img src="../../../assets/mail-icon.svg" alt="Email Marketing" class="logo" />
                <div class="text">{{ $t("emailMarketingOptionText") }}</div>
            </div>
            <div class="card" @click="toggleCheckbox($event)">
                <label class="check-box">
                    <input type="checkbox" ref="checkbox" />
                    <span class="checkmark"></span>
                </label>
                <img src="../../../assets/community-icon.svg" alt="Network Recommendation" class="logo" />
                <div class="text">{{ $t("networkRecommendationOptionText") }}</div>
            </div>
            <div class="card" @click="toggleCheckbox($event)">
                <label class="check-box">
                    <input type="checkbox" ref="checkbox" />
                    <span class="checkmark"></span>
                </label>
                <img src="../../../assets/google-icon.svg" alt="Google Search" class="logo" />
                <div class="text">{{ $t("googleSearchOptionText") }}</div>
            </div>
        </div>
            </div>
        </div>
    </div>
</template>

<script>
import { saveToLocalStorage, loadFromLocalStorage } from "../../../utils/formStore";

export default {
    name: "SurveyQuestions",
    data() {
        return {
            isOpen: false,
            isSectorOpen: false,
            selectedText: this.$t("dropdownPlaceholderText"),
            selectedSector: '',
            answers: {
                sector: '',
                otherSector: '',
                department: '',
                otherDepartment: '',
                heardAboutUs: []
            }
        };
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
        this.$nextTick(() => {
            if (this.answers.heardAboutUs && this.answers.heardAboutUs.length > 0) {
                const cards = this.$el.querySelectorAll('.card');
                cards.forEach(card => {
                    const text = card.querySelector('.text').innerText;
                    const checkbox = card.querySelector('input[type="checkbox"]');
                    if (this.answers.heardAboutUs.includes(text)) {
                        checkbox.checked = true;
                    }
                });
            }
        });
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectItem(event) {
            const value = event.target.getAttribute('data-value');
            this.selectedText = value;
            this.answers.department = value;
            this.saveAnswers();
            this.isOpen = false;
        },
        handleClickOutside(event) {
            if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.isOpen = false;
            }
            if (this.$refs.sectorDropdown && !this.$refs.sectorDropdown.contains(event.target)) {
                this.isSectorOpen = false;
            }
        },
        toggleSectorDropdown() {
            this.isSectorOpen = !this.isSectorOpen;
        },
        selectSector(event) {
            const value = event.target.getAttribute('data-value');
            this.selectedSector = value;
            this.answers.sector = value;
            this.saveAnswers();
            this.isSectorOpen = false;
        },
        toggleCheckbox(event) {
            const checkbox = event.currentTarget.querySelector('input[type="checkbox"]');
            const value = event.currentTarget.querySelector('.text').innerText;

            const isChecked = !checkbox.checked;
            checkbox.checked = isChecked;

            if(isChecked) {
                this.answers.heardAboutUs.push(value);
            } else {
                const index = this.answers.heardAboutUs.indexOf(value);
                this.answers.heardAboutUs.splice(index, 1);
            }
            this.saveAnswers();
        },
        saveAnswers() {
            saveToLocalStorage({ surveyAnswers: this.answers });
        }
    },
    watch: {
        answers: {
            handler() {
                this.saveAnswers();
            },
            deep: true
        }
    },
    created() {
        const saved = loadFromLocalStorage().surveyAnswers || {};
        this.answers = {
            sector: saved.sector || '',
            otherSector: saved.otherSector || '',
            department: saved.department || '',
            otherDepartment: saved.otherDepartment || '',
            heardAboutUs: saved.heardAboutUs || []
        };
        this.selectedText = this.answers.department || this.$t("dropdownPlaceholderText");
        this.selectedSector = this.answers.sector || '';
    }
};
</script>

<style lang="scss" scoped>
@keyframes slideDown {
    0% {
        opacity: 0;
        transform: translateY(-50px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

#SurveyQuestions {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background-image: url("../../../assets/BackgroundOne.png");
    background-repeat: no-repeat;
    background-size: cover;

    .title-text {
        font-family: 'Plus Jakarta Sans', sans-serif;
        padding: 0 20px;
        animation: slideDown 1.5s ease;

        h1 {
            font-size: 2rem;
            color: #272657;
            font-weight: bold;

            @media (max-width: 768px) {
                font-size: 1.8rem;
                text-align: center;
            }
        }
    }

    @media(max-width: 768px) {
        .content {
            overflow-y: auto !important;
        }
        .module-survey-questions{
            height: 43vh !important;
        }
    }


    .content {
        display: flex;
        justify-content: center;
        padding: 0 20px;

        .module-survey-questions {
            position: relative;
            padding: 30px;
            background: #fff;
            width: 600px;
            height: 57vh;
            border-radius: 20px;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
            animation: fadeIn 2s ease;
            display: flex;
            flex-direction: column;
            overflow: auto;
            overflow-x: hidden;

            .question {
                display: flex;
                flex-direction: column;
                gap: 10px;
                margin-bottom: 20px;

                .question-label {
                    font-family: "Plus Jakarta Sans", sans-serif;
                    font-size: 1.1rem;
                    font-weight: 600;
                    color: #272657;
                    text-align: left;
                    padding-left: 10px;
                    margin-bottom: 5px;
                }

                .question-input {
                    padding: 14px 16px;
                    font-size: 1rem;
                    color: #272657;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    outline: none;
                    transition: all 0.3s ease;

                    &:focus {
                        outline: none;
                        border-color: #272657;
                    }

                    &::placeholder {
                        color: #c4c4c4;
                    }

                    &:hover {
                        border-color: #272657;
                    }
                }

                .custom-dropdown {
                    position: relative;
                    width: 100%;
                    font-family: "Plus Jakarta Sans", sans-serif;

                    .dropdown-header {
                        padding: 12px 14px;
                        font-size: 1rem;
                        color: #272657;
                        border: 1px solid #ddd;
                        border-radius: 8px;
                        cursor: pointer;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        background-color: #fff;
                        transition: border-color 0.3s ease;

                        &:focus,
                        &:hover {
                            border-color: #272657;
                        }
                    }

                    .dropdown-arrow {
                        border-left: 5px solid transparent;
                        border-right: 5px solid transparent;
                        border-top: 6px solid #272657;
                        transition: transform 0.3s ease;
                    }

                    .dropdown-list {
                        position: absolute;
                        top: 100%;
                        left: 0;
                        width: 100%;
                        max-height: 200px;
                        overflow-y: auto;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-radius: 8px;
                        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
                        z-index: 9999;
                        opacity: 0;
                        visibility: hidden;
                        transition: all 0.3s ease;
                        list-style: none;
                        transform: translateY(-10px);

                        &.open {
                            opacity: 1;
                            visibility: visible;
                            padding: 0;
                        }

                        .dropdown-item {
                            padding: 10px 16px;
                            font-size: 1rem;
                            color: #272657;
                            cursor: pointer;
                            transition: background-color 0.2s ease;
                            text-align: left;

                            &:hover {
                                background-color: #f4f4f8;
                            }
                        }
                    }

                    &.active .dropdown-arrow {
                        transform: rotate(180deg);
                    }
                }

                .logo {
                    width: 24px;
                    height: 24px;
                    margin-right: 10px;
                    user-select: none;
                }

                .card {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    border: 1px solid #ccc;
                    border-radius: 10px;
                    padding: 15px;
                    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);

                    &:hover {
                        transform: translateY(-5px) scale(1.02);
                        box-shadow: 0 8px 20px rgba(93, 91, 141, 0.15);
                    }

                    .check-box {
                        margin-right: 15px;
                        position: relative;
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        input {
                            position: absolute;
                            opacity: 0;
                            cursor: pointer;

                            &:checked ~ .checkmark {
                                background-color: #5d5b8d;
                                border: 1px solid #5d5b8d;
                            }

                            &:checked ~ .checkmark::after {
                                display: block;
                            }
                        }

                        .checkmark {
                            height: 24px;
                            width: 24px;
                            background-color: #fff;
                            border: 1px solid #ccc;
                            border-radius: 50%;
                            display: inline-block;
                            position: relative;
                            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

                            &::after {
                                content: "";
                                position: absolute;
                                display: none;
                                left: 8px;
                                top: 4px;
                                width: 6px;
                                height: 10px;
                                border: solid #fff;
                                border-width: 0 2px 2px 0;
                                transform: rotate(45deg);
                                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                            }
                        }
                    }

                    .text {
                        flex: 1;
                        text-align: left;
                        font-family: 'Plus Jakarta Sans', sans-serif;
                        font-size: 0.9rem;
                        color: #272657;
                    }

                    &:focus-within {
                        border-color: #5d5b8d;
                    }
                }
            }
        }
    }
}
</style>